// AI-CONTEXT: See docs/features/msi-effect-monetisation.md
// AI-CONTEXT: See docs/features/arbeidsparticipatie-1-0.md
//
// Whether an MSI effect is left out of the MSI monetisation stream, and why.
// One place, because five consumers decide it (the dashboard total, the
// breakdown, the per-effect card, and the nightly total in functions/).
//
// Two reasons:
//   participatieladder - its value comes from the kenmerken-based ladder
//                        stream; counting both would double-count.
//   samengevoegd       - another effect of the same organisation carries this
//                        value. Arbeidsparticipatie 1.0 merged Zelf-effectiviteit
//                        and Empowerment into one effect; an organisation that
//                        had both keeps both, and only one may be valued
//                        (besluit gebruiker 2026-10-20).
//
// Mirrored by functions/msiMonetisationHelpers/msiValueExclusion.js — parity is
// pinned by its test.
import PARTICIPATIELADDER_MSI_ID from './participatieladderMsiId'

/** OutputEffects field holding the ID of the effect that carries this effect's value. */
const MSI_VALUE_COUNTED_BY_FIELD = 'MSIValueCountedBy'

/**
 * @typedef {object} MsiValueExclusion
 * @property {'participatieladder'|'samengevoegd'} reason
 * @property {string|null} countedBy - OutputEffects.ID that carries the value, for 'samengevoegd'
 */

/**
 * @param {{ID?: string, MSIId?: string, MSIValueCountedBy?: string}|null|undefined} effect - OutputEffects doc
 * @returns {MsiValueExclusion|null} null when the effect counts
 */
const msiValueExclusion = (effect) => {
    if (!effect) return null
    if (effect.MSIId === PARTICIPATIELADDER_MSI_ID) return { reason: 'participatieladder', countedBy: null }

    const countedBy = effect[MSI_VALUE_COUNTED_BY_FIELD]
    if (typeof countedBy === 'string' && countedBy !== '' && countedBy !== effect.ID) {
        return { reason: 'samengevoegd', countedBy }
    }
    return null
}

export default msiValueExclusion
export { MSI_VALUE_COUNTED_BY_FIELD }
